import _Vue from "vue";
import Notification from "./notification";

const install = (Vue: typeof _Vue) => {
  const notification = new Notification();
  Vue.prototype.$notification = notification;
  (Vue as any).$notification = notification;
}
  
  const notification = {
      install
  }
  
  export default notification



// WEBPACK FOOTER //
// ./scripts/plugins/notification/plugin.notification.ts